export const ASSET_CLASSES = ['US Stock', 'Crypto', 'ETF', 'Gold'];

export const SECTOR_MAPPING = {
  Technology: ['AAPL', 'MSFT', 'GOOGL', 'META', 'NVDA', 'TSLA'],
  Finance: ['JPM', 'BAC', 'WFC', 'GS', 'MS', 'BRK.B'],
  Healthcare: ['JNJ', 'PFE', 'UNH', 'ABT', 'TMO', 'DHR'],
  Consumer: ['AMZN', 'WMT', 'HD', 'MCD', 'NKE', 'COST'],
  Energy: ['XOM', 'CVX', 'COP', 'EOG', 'SLB'],
  Industrial: ['CAT', 'DE', 'GE', 'MMM', 'HON', 'UPS'],
  Materials: ['LIN', 'BHP', 'RIO', 'DOW', 'DD'],
  Utilities: ['NEE', 'DUK', 'SO', 'AEP', 'EXC'],
  'Real Estate': ['AMT', 'PLD', 'CCI', 'EQIX', 'PSA'],
  Communication: ['VZ', 'T', 'CMCSA', 'DIS', 'NFLX'],
  Crypto: ['BTC', 'ETH', 'BNB', 'ADA', 'SOL', 'DOT'],
  Gold: ['XAUUSD', 'GOLDTHB'],
  ETF: ['SPY', 'QQQ', 'VTI', 'VOO', 'IWM', 'EFA', 'EEM', 'GLD', 'IAU', 'GDX', 'GDXJ', 'PHYS']
};

export const initialTransactions = [];

export const GOOGLE_SHEET_CSV_URL = 'https://docs.google.com/spreadsheets/d/1MtqXbhrGC763WLPns9GOACpAq9UXQMZ38gf5IT6lvTs/export?format=csv&gid=1926459604';

// URL สำหรับดึงอัตราแลกเปลี่ยน USD/THB จาก Google Sheets
// ใน Google Sheets ให้สร้าง sheet ใหม่ที่มี 2 คอลัมน์: Currency, Rate
// เช่น: THB, 34.50 (หรือใช้สูตร =GOOGLEFINANCE("CURRENCY:USDTHB") เพื่อดึงเรทอัตโนมัติ)
export const EXCHANGE_RATE_CSV_URL = 'https://docs.google.com/spreadsheets/d/1MtqXbhrGC763WLPns9GOACpAq9UXQMZ38gf5IT6lvTs/export?format=csv&gid=1926459604';
